import styled from 'styled-components';
import {
  hideCompareTooltip,
  updateCompareItems
} from '../../../redux/slices/compareSlice';
import { MouseEvent } from 'react';
import { EntityTypes } from '../../../new-lib/constants/common';
import { getCompareListIds } from '../helpers';
import { useDispatch, useSelector } from 'react-redux';
import CompareIcon from '../../../new-components/svg-icons/CompareIcon';
import StartCompareToolTip from './StartCompareToolTip';

interface CardCompareIconProps {
  entity: any;
  entityType: EntityTypes;
  cardPosition?: number;
  showToolTip?: boolean;
}

interface ContainerProps {
  isActive: boolean;
}

const CardCompareIcon = ({
  entity,
  entityType,
  showToolTip
}: CardCompareIconProps) => {
  const isMobile = useSelector((state: any) => state.app.isMobile);

  const showStartCompare = useSelector(
    (state: any) => state.compare.show_compare_tooltip
  );
  const compareListIds = useSelector(state =>
    getCompareListIds(state, entityType)
  );

  const dispatch = useDispatch();

  const entityIsInCompareList = () => {
    return compareListIds.includes(entity?.id);
  };

  const handleClick = (e: MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();

    dispatch(
      updateCompareItems({
        compare_type:
          entityType === EntityTypes.COMPOUND ? 'compounds' : 'properties',
        item_id: entity.id,
        isMobile,
        fireEvent: true
      })
    );

    dispatch(hideCompareTooltip());
  };

  return (
    <Container onClick={e => handleClick(e)} isActive={entityIsInCompareList()} className="icon">
      <CompareIcon fill="#FFFFFF" />
      {showToolTip && showStartCompare && <StartCompareToolTip />}
    </Container>
  );
};

const Container = styled.div<ContainerProps>`
  position: relative;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background-color: ${props =>
    props.isActive ? '#015C9A !important' : 'rgba(0, 0, 0, 0.7)'};
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    position: absolute;
    width: 60% !important;
    height: 60% !important;
  }
`;

export default CardCompareIcon;
